import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=525e5c70&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525e5c70')) {
      api.createRecord('525e5c70', component.options)
    } else {
      api.reload('525e5c70', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=525e5c70&", function () {
      api.rerender('525e5c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/workflow/edit.vue"
export default component.exports